import { createSlice } from "@reduxjs/toolkit";
import { getLedgerEntryReport } from "./actions/ledgerEntry.actions";

const initialState = {
  ledgerEntryReport: null,
  totalLedgerEntryReport: 0,
  ledgerEntReportFilters: {},
  ledgerEntReportPageState: { page: 1, pageSize: 50 },
};

export const ledgerEntrySlice = createSlice({
  name: "ledgerEntry",
  initialState,
  reducers: {
    setLedgerEntReportFilters: (state, action) => {
      const { payload } = action;
      state.ledgerEntReportFilters = payload || {};
    },
    resetLedgerEntReportFilters: (state) => {
      state.ledgerEntReportFilters = {};
    },
    setLedgerEntReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.ledgerEntReportPageState = {
          ...state.ledgerEntReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.ledgerEntReportPageState = {
          ...state.ledgerEntReportPageState,
          pageSize,
        };
      }
    },
  },
  extraReducers: (builder) => {


    builder
      .addCase(getLedgerEntryReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLedgerEntryReport.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.ledgerEntryReport = data;
        state.totalLedgerEntryReport = count;
      })
      .addCase(getLedgerEntryReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setLedgerEntReportPage,
  resetLedgerEntReportFilters, setLedgerEntReportFilters } = ledgerEntrySlice.actions;

export default ledgerEntrySlice.reducer;
